import { createAction } from "@reduxjs/toolkit"; // Toggle the facet filters modal on mobile

export var closeAdultModal = createAction("CLOSE_ADULT_MODAL");